// Canonical public destinations, shared by desktop and mobile navigation.
export const publicLinks = {
  home: "https://saleshive.cloud",
  about: "https://digitalhive.in/about-digital-hive/",
  login: "https://app.saleshive.cloud/signin",
  register: "https://app.saleshive.cloud/register",
  privacy: "https://saleshive.cloud/privacy-policy/",
  terms: "https://saleshive.cloud/terms-conditions/",
  blog: "https://saleshive.cloud/blog/",
  contact: "https://saleshive.cloud/contact-us/",
};

export const publicNavGroups = [
  {
    label: "Solutions",
    links: [
      ["CRM for Real Estate", "crm-for-real-estate"],
      ["Small Business / SME CRM", "small-business-crm"],
      ["CRM for Startups", "crm-for-startups"],
      ["CRM for Manufacturers", "crm-for-manufacturers"],
      [
        "CRM for Transport & Freight Companies",
        "crm-for-transport-freight-companies",
      ],
      [
        "CRM for Solar Installers & EPC Companies",
        "crm-for-solar-installers-epc-companies",
      ],
      ["CRM for Education Consultants", "crm-for-education-consultants"],
    ].map(([label, slug]) => ({ label, href: `${publicLinks.home}/${slug}/` })),
  },
  { label: "Resources", links: [{ label: "Blog", href: publicLinks.blog }] },
];

export const publicFooterLinks = [
  { label: "Home", href: publicLinks.home },
  { label: "Privacy Policy", href: publicLinks.privacy },
  { label: "Terms & Conditions", href: publicLinks.terms },
  { label: "Blog", href: publicLinks.blog },
  { label: "Contact Us", href: publicLinks.contact },
  {
    label: "About Us",
    href: "https://digitalhive.in/about-us/",
    target: "_blank",
  },
];
